var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue, PropSync, Prop } from 'vue-property-decorator';
import Modal from 'components/Modal.vue';
let SearchHistoryRemoveModal = class SearchHistoryRemoveModal extends Vue {
    confirmRemove() {
        this.showModal = false;
        this.$emit('onRemove', this.history.id);
    }
};
__decorate([
    PropSync('open', { default: false })
], SearchHistoryRemoveModal.prototype, "showModal", void 0);
__decorate([
    Prop({ default: () => { } })
], SearchHistoryRemoveModal.prototype, "history", void 0);
SearchHistoryRemoveModal = __decorate([
    Component({
        name: 'SearchHistoryRemoveModal',
        components: {
            Modal,
        },
    })
], SearchHistoryRemoveModal);
export default SearchHistoryRemoveModal;
